import React, { useEffect, useRef } from "react";
import Typed from "typed.js";
import bitcoinIcon from "../../images/front/bitcoin-hero.svg";
import blocksIcon from "../../images/front/building-blocks.svg";
import mobileBitcoin from "../../images/front/bitcoin-mobile.svg";
import mobileBlocks from "../../images/front/blocks-mobile.svg";
import uniswapLogo from "../../images/front/uniswap-white.svg";
import sushiLogo from "../../images/front/sushi-hero.svg";
import galxeLogo from "../../images/front/galxe-hero.svg";
import ledgerLogo from "../../images/front/ledger-hero.svg";
import metamaskLogo from "../../images/front/metamask-hero.png";
import mocLogo from "../../images/front/moc-hero.png";
import beefyLogo from "../../images/front/beefy-hero.svg";
import graphLogo from "../../images/front/thegraph-hero.svg";
import alchemyLogo from "../../images/front/alchemy-hero.svg";
import layerzeroLogo from "../../images/front/layerzero3.svg";
import ImageSlider from "./ImageSlider";
import AddRootstockButton from "./AddRootstockButton";

const NewIntro = () => {
  const logos = [
    { src: uniswapLogo, alt: "Uniswap logo" },
    { src: sushiLogo, alt: "SushiSwap logo" },
    { src: galxeLogo, alt: "Galxe logo" },
    { src: ledgerLogo, alt: "Ledger logo" },
    { src: metamaskLogo, alt: "MetaMask logo" },
    { src: mocLogo, alt: "MOC logo" },
    { src: beefyLogo, alt: "Beefy Finance logo" },
    { src: graphLogo, alt: "The Graph logo" },
    { src: alchemyLogo, alt: "Alchemy logo" },
    { src: layerzeroLogo, alt: "LayerZero logo" },
  ];

  // Refs for typed animation
  const bitcoinRef = useRef(null);
  const redefinedRef = useRef(null);
  const bitcoinIconRef = useRef(null);
  const mobileBitcoinIconRef = useRef(null);
  const blocksIconRef = useRef(null);
  const mobileBlocksIconRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const typedOptions = {
      showCursor: false,
      typeSpeed: 30,
    };

    let delay = 0;

    // Type "Bitcoin"
    const bitcoinTyped = new Typed(bitcoinRef.current, {
      ...typedOptions,
      strings: ["Bitcoin"],
      startDelay: delay,
      preStringTyped: () => bitcoinRef.current.classList.remove("opacity-0"),
    });

    delay += 7 * typedOptions.typeSpeed; // Approximate delay for "Bitcoin"

    // Type "Redefined"
    const redefinedTyped = new Typed(redefinedRef.current, {
      ...typedOptions,
      strings: ["Redefined"],
      startDelay: delay,
      preStringTyped: () => redefinedRef.current.classList.remove("opacity-0"),
      onComplete: () => {
        console.log("Typing complete - revealing elements");

        // Ensure refs exist before modifying them
        if (bitcoinIconRef.current) {
          bitcoinIconRef.current.classList.remove("opacity-0");
          console.log("Bitcoin Icon revealed");
        }

        if (mobileBitcoinIconRef.current) {
          mobileBitcoinIconRef.current.classList.remove("opacity-0");
          console.log("Mobile Bitcoin Icon revealed");
        }

        if (blocksIconRef.current) {
          blocksIconRef.current.classList.remove("opacity-0");
          console.log("Blocks Icon revealed");
        }

        if (mobileBlocksIconRef.current) {
          mobileBlocksIconRef.current.classList.remove("opacity-0");
          console.log("Mobile Blocks Icon revealed");
        }

        if (contentRef.current) {
          contentRef.current.classList.remove("opacity-0");
          console.log("Content revealed");
        }
      },
    });

    return () => {
      bitcoinTyped.destroy();
      redefinedTyped.destroy();
    };
  }, []);

  return (
    <section className="new-hero-section pt-14-rem pb-lg-16 pb-11">
      <div className="container">
        {/* Bitcoin Redefined Header */}
        <div className="hero-header">
          <div className="header-wrapper">
            {/* Bitcoin Icon */}
            <img
              ref={bitcoinIconRef}
              src={bitcoinIcon}
              alt="Bitcoin illustration"
              className="bitcoin-icon hidden-mobile opacity-0 transition-opacity"
            />
            <img
              ref={mobileBitcoinIconRef}
              src={mobileBitcoin}
              alt="Bitcoin illustration"
              className="bitcoin-icon hidden-desktop opacity-0 transition-opacity"
            />

            {/* Title with typing animation */}
            <h1 className="hero-title">
              <span ref={bitcoinRef} className="zg-text-bg bg-orange text-black mb-2 mb-md-3 me-1 me-md-2 opacity-0"></span>{" "}
              <br />
              <span ref={redefinedRef} className="zg-text-bg bg-white text-black me-1 me-md-2 opacity-0"></span>
            </h1>

            {/* Blocks Icon */}
            <img
              ref={blocksIconRef}
              src={blocksIcon}
              alt="Icon"
              className="icon-right hidden-mobile opacity-0 transition-opacity"
            />
            <img
              ref={mobileBlocksIconRef}
              src={mobileBlocks}
              alt="Icon"
              className="icon-right hidden-desktop opacity-0 transition-opacity"
            />
          </div>
        </div>

        {/* Subtitle, Button & Slider */}
        <div ref={contentRef} className="opacity-0 transition-opacity">
          <div className="d-flex justify-content-center">
            <p className="hero-subtitle">
              Do more with Bitcoin on Rootstock.<br />The Bitcoin DeFi Layer.
            </p>
          </div>

          <AddRootstockButton />

          <p className="trusted-text">Trusted by the best</p>
          <ImageSlider images={logos} />
        </div>
      </div>
    </section>
  );
};

export default NewIntro;


